export function getBrandName() {
    try {
      const host = window.location.hostname; // e.g. "www.bajibd.shop"
      const parts = host.split(".");
  
      const brand = parts[0] === "www" ? parts[1] : parts[0];
  
      return brand ? brand.toUpperCase() : "";
    } catch (error) {
      console.warn("Unable to get brand name from hostname:", error);
      return "";
    }
  }